import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CartTable from "./CartTable";
import { CURRENCY } from "utils/textConstants";
import { MdOutlineRemoveShoppingCart } from "react-icons/md";
import RecentArticles from "../recentArticles/RecentArticles";
import Baners from "../baners/Baners";
import { useEffect, useState } from "react";
import { goToTop } from "utils/helpers/screenOperations";
import { AppDispatch } from "store";
import {
  getConfigParam,
  getCourier,
  newOrder,
  resetOrder,
  updateOrder,
} from "store/order/order.slice";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Progress } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { CheckBoxField, InputField } from "components";
import { useTranslation } from "react-i18next";
import TextAreaField from "components/form/TextAreaField";
import {
  calculateCart,
  getPromoCodeDiscount,
  resetCart,
} from "store/cart/cart.slice";
import * as Yup from "yup";
import "../homePage/HomePage.scss";
import "./CartPage.scss";
import "./CartInfo.scss";
import OrderError from "../order/OrderError";
import OrderSuccess from "../order/OrderSuccess";

const CartPage = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [device, orientation] = useEffectDeviceAndOrientation();
  const nameOfClass =
    (device === "mobile" && orientation === "portrait") ||
    orientation === "portrait"
      ? "-Mobile"
      : "";
  const { t } = useTranslation("order", { useSuspense: false });
  const cart = useSelector((store: any) => store.cart);
  const order = useSelector((store: any) => store.order);
  const [step, setStep] = useState(0);
  const [deliveryCost, setDeliveryCost] = useState(0);
  useEffect(() => {
    // minimalan iznos besplatne dostave
    dispatch(getConfigParam(null));
    //kurirske sluzbe
    dispatch(getCourier(null)).then((e) => {
      if (e.type === "order/getCourier/fulfilled") {
        setDeliveryCost(e.payload[0].delivery_cost);
      }
    });
  }, [dispatch]);

  const nextStep = (values?: any) => {
    if (values.promo_code) {
      //promo kod i popust
      dispatch(getPromoCodeDiscount(values.promo_code)).then((e) => {
        if (e.type === "cart/getPromoCodeDiscount/fulfilled") {
          dispatch(calculateCart());
        }
      });
    }
    dispatch(updateOrder(values));
    setStep(1);
    goToTop();
  };

  const calculateProgress = (): number => {

    return ((step + 1) / 3) * 100;
  };
  const calculateFreeDelivery = () => {
    let num = order.config_param - cart.final_price;
    if (num < 0) {
      return "Vaša dostava je besplatna";
    } else {
      return `Treba vam još ${num.toFixed(
        2
      )} ${CURRENCY} do besplatne dostave.`;
    }
  };
  // Funkcija za povratak na prethodni obrazac
  const handleBack = (values: any) => {
    if (step > 0) {
      setStep(step - 1);
    }
    dispatch(updateOrder(values));
    goToTop();
  };

  // funkcija za postavljanje vrednosti na obicna polja
  const handleCustomChange = (event: any, setFieldValue: any) => {
    const { name, value } = event.target;
    setFieldValue(name, value);
  };
  // funkcija za postavljanje vrednosti na chechbox polja
  // setFieldValue - iz formika dolazi
  const handleCheckboxChange = (event: any, setFieldValue: any) => {
    const { name, checked } = event.target;
    setFieldValue(name, checked);
  };
  const getDeliveryPrice = (orderType: string) => {
    if (orderType === "na_kucnu_adresu") {
      if (cart.final_price >= order.config_param) {
        return 0;
      } else {
        return deliveryCost; //todo izbor poste
      }
    } else {
      return 0;
    }
  };

  // yup objekat za validaciju 1. stepa
  const currentValidationSchema = Yup.object({
    first_name: Yup.string().required(t("ime_required")),
    last_name: Yup.string().required(t("prezime_required")),
    telephone: Yup.string().required(t("telefon_required")),
    email: Yup.string().email(t("email_valid")),
    // .required(t("email_required")),
    // person: Yup.string()
    //   .required(t("da_li_ste_pravno_lice_required"))
    //   .oneOf(["fizicko_lice", "pravno_lice"], t("nevazeca_opcija")),
    company_name: Yup.string().when("person", (r, schema) =>
      r.toString() === "pravno_lice"
        ? schema.required(t("naziv_kompanije_required"))
        : schema.notRequired()
    ),
    // receiving_way: Yup.string()
    //   .required(t("nacin_dostave_required"))
    //   .oneOf(["na_kucnu_adresu", "na_adresu_firme"], t("nevazeca_opcija")),
    state: Yup.string().when("receiving_way", (r, schema) =>
      r.toString() === "na_kucnu_adresu"
        ? schema.required(t("drzava_required"))
        : schema.notRequired()
    ),
    city: Yup.string().when("receiving_way", (r, schema) =>
      r.toString() === "na_kucnu_adresu"
        ? schema.required(t("grad_required"))
        : schema.notRequired()
    ),
    zip: Yup.string().when("receiving_way", (r, schema) =>
      r.toString() === "na_kucnu_adresu"
        ? schema.required(t("postanski_broj_required"))
        : schema.notRequired()
    ),
    address: Yup.string().when("receiving_way", (r, schema) =>
      r.toString() === "na_kucnu_adresu"
        ? schema.required(t("ulica_required"))
        : schema.notRequired()
    ),
    // method_of_payment: Yup.string()
    //   .required(t("nacin_placanja_required"))
    //   .oneOf(
    //     ["placanje_prilikom_preuzimanja", "placanje_karticom"],
    //     t("nevazeca_opcija")
    //   ),
    agreement: Yup.boolean().oneOf([true], t("saglasnost_required")),
    promo_code: Yup.string()
      .max(30, "Promo kod ne može biti duži od 30 karaktera")
      .notRequired(),
  });

  // submit forme kada se klikne a kada je sve validno
  const onSubmit = async (values: any, setSubmitting: any) => {

    dispatch(newOrder({ order_data: values, cart_data: cart })).then(
      (rez: any) => {
        setSubmitting(false);
        setStep(step + 1);
        if (rez.type === "order/newOrder/fulfilled") {
          // setTimeout(() => {
          //   navigate("/");
          // }, 2000);
          dispatch(resetCart());
          goToTop();
        } else if (rez.type === "order/newOrder/rejected") {
          // setTimeout(() => {
          //   navigate("/cart");
          //   setStep(0);
          // }, 2000);
          dispatch(updateOrder(values));
        }
      }
    );
  };

  {
    step === 2 && (order.error ? <OrderError /> : <OrderSuccess />);
  }
  if (step === 2) {
    if (order.error) {
      return <OrderError />;
    } else {
      return <OrderSuccess />;
    }
  }
  if (step === 0 && cart.total_count === 0) {
    dispatch(resetOrder());
    return (
      <div className="Cart-Page Empty-Cart">
        <MdOutlineRemoveShoppingCart size="10%" />
        <label>Vaša korpa je prazna</label>
      </div>
    );
  }

  return (
    <div className="Page">
      <div className="Page-Content">
        <h2 className="Page-Title">Vaša korpa</h2>
        <Formik
          initialValues={order.data}
          validationSchema={currentValidationSchema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values, { setSubmitting }) =>
            onSubmit(values, setSubmitting)
          }
        >
          {({
            errors,
            touched,
            values,
            isSubmitting,
            isValidating,
            isValid,
            setFieldValue,
            validateField,
          }) => (
            <Form className="Cart-Page">
              {step === 0 && (
                <div className="Cart-Page-Box1">
                  {/* Progres linija */}
                  <Progress
                    percent={calculateProgress()}
                    status="active"
                    strokeColor="#ea252e"
                    trailColor="var(--text-tertial)"
                    showInfo={false}
                    size={["100%", 10]}
                  />
                  <label style={{ textAlign: "left", width: "100%" }}>
                    {calculateFreeDelivery()}
                  </label>
                  <label style={{ textAlign: "left", width: "100%" }}>
                    * Poštarina je besplatna za iznos preko&nbsp;
                    {order.config_param}&nbsp;
                    {CURRENCY}
                  </label>
                  <div className="Cart-Page-Box1-Item">
                    <CartTable cartList={cart.list} view={false} />
                  </div>
                </div>
              )}
              {order.is_loading ? (
                <LoadingOutlined />
              ) : (
                step === 1 && (
                  <div className="Cart-Page-Box3">
                    {/* Progres linija */}
                    <Progress
                      percent={calculateProgress()}
                      status="active"
                      strokeColor="#ea252e"
                      trailColor="var(--text-tertial)"
                      showInfo={false}
                      size={["100%", 10]}
                    />
                    <label style={{ textAlign: "left", width: "100%" }}>
                      {calculateFreeDelivery()}
                    </label>
                    <label style={{ textAlign: "left", width: "100%" }}>
                      * Poštarina je besplatna za iznos preko&nbsp;
                      {order.config_param}&nbsp;
                      {CURRENCY}
                    </label>
                    <div className="Order-Page">
                      <div className="Order-Form-Box">
                        <div className="Formik-Group">
                          <div>
                            <InputField
                              name="first_name"
                              label={t("ime")}
                              required={true}
                              onChange={(event: any) => {
                                handleCustomChange(event, setFieldValue);
                              }}
                            />
                          </div>
                          <div>
                            <InputField
                              name="last_name"
                              label={t("prezime")}
                              required={true}
                              onChange={(event: any) =>
                                handleCustomChange(event, setFieldValue)
                              }
                            />
                          </div>
                        </div>
                        <div className="Formik-Group">
                          <div>
                            <InputField
                              name="telephone"
                              label={t("telefon")}
                              required={true}
                              onChange={(event: any) =>
                                handleCustomChange(event, setFieldValue)
                              }
                            />
                          </div>
                          <div>
                            <InputField
                              name="email"
                              label={t("email")}
                              required={false}
                              onChange={(event: any) =>
                                handleCustomChange(event, setFieldValue)
                              }
                            />
                          </div>
                        </div>
                        <div className="Formik-Group">
                          <div className="Select-Field">
                            <label
                              className="Select-Field-Label"
                              htmlFor="person"
                            >
                              {t("da_li_ste_pravno_lice")} *
                            </label>
                            <Field
                              className="Select-Field-Selector"
                              as="select"
                              name="person"
                              id="person"
                              onChange={(event: any) =>
                                handleCustomChange(event, setFieldValue)
                              }
                            >
                              <option
                                className="Select-Option"
                                value="fizicko_lice"
                                key="fizicko_lice"
                              >
                                {t("fizicko_lice")}
                              </option>
                              <option value="pravno_lice" key="pravno_lice">
                                {t("pravno_lice")}
                              </option>
                            </Field>
                          </div>
                          <div>
                            {values.person === "pravno_lice" && (
                              <InputField
                                name="company_name"
                                label={t("naziv_kompanije")}
                                required={true}
                                onChange={(event: any) =>
                                  handleCustomChange(event, setFieldValue)
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="Select-Field">
                          <label
                            className="Select-Field-Label"
                            htmlFor="receiving_way"
                          >
                            {t("nacin_dostave")}
                          </label>
                          <Field
                            className="Select-Field-Selector"
                            as="select"
                            name="receiving_way"
                            id="receiving_way"
                            onChange={(event: any) => {
                              handleCustomChange(event, setFieldValue);
                            }}
                          >
                            <option value="na_adresu_infocompa">
                              {t("na_adresu_infocompa")}
                            </option>
                            <option value="na_kucnu_adresu">
                              {t("na_kucnu_adresu")}
                            </option>
                          </Field>
                          {/* {touched?.receiving_way && errors?.receiving_way && (
            <div className="error">{errors.receiving_way}</div>
          )} */}
                        </div>
                        {values.receiving_way === "na_kucnu_adresu" && (
                          <>
                            <div className="Formik-Group">
                              <div>
                                <InputField
                                  name="state"
                                  label={t("drzava")}
                                  required={
                                    values.receiving_way === "na_kucnu_adresu"
                                      ? true
                                      : false
                                  }
                                  onChange={(event: any) => {
                                    handleCustomChange(event, setFieldValue);
                                  }}
                                />
                              </div>
                              <div>
                                <InputField
                                  name="city"
                                  label={t("grad")}
                                  required={
                                    values.receiving_way === "na_kucnu_adresu"
                                      ? true
                                      : false
                                  }
                                  onChange={(event: any) => {
                                    handleCustomChange(event, setFieldValue);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="Formik-Group">
                              <div>
                                <InputField
                                  name="zip"
                                  label={t("postanski_broj")}
                                  required={
                                    values.receiving_way === "na_kucnu_adresu"
                                      ? true
                                      : false
                                  }
                                  onChange={(event: any) => {
                                    handleCustomChange(event, setFieldValue);
                                  }}
                                />
                              </div>
                              <div>
                                <InputField
                                  name="address"
                                  label={t("ulica")}
                                  required={
                                    values.receiving_way === "na_kucnu_adresu"
                                      ? true
                                      : false
                                  }
                                  onChange={(event: any) => {
                                    handleCustomChange(event, setFieldValue);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="Formik-Group">
                              <div>
                                <InputField
                                  name="address_addition"
                                  label={t("ulica_dodatno")}
                                  required={false}
                                  onChange={(event: any) => {
                                    handleCustomChange(event, setFieldValue);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="Select-Field">
                              <label
                                className="Select-Field-Label"
                                htmlFor="courier_id"
                              >
                                Izbor kurirske službe
                              </label>
                              <Field
                                className="Select-Field-Selector"
                                as="select"
                                name="courier_id"
                                id="courier_id"
                                onChange={(event: any) => {
                                  setDeliveryCost(
                                    order.couriers.filter(
                                      (item: any) =>
                                        item.id == event.target.value
                                    )[0].delivery_cost
                                  );
                                  handleCustomChange(event, setFieldValue);
                                }}
                              >
                                {order.couriers.map((item: any) => (
                                  <option value={item.id} key={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </>
                        )}
                        <div className="Formik-Group">
                          <TextAreaField
                            name="description"
                            label={t("dodatna_napomena")}
                            maxLength={500}
                            onChange={(event: any) => {
                              handleCustomChange(event, setFieldValue);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {nameOfClass === "" && (
                      <button type="button" onClick={() => handleBack(values)}>
                        Nazad
                      </button>
                    )}
                  </div>
                )
              )}

              {step < 2 && (
                <div className="Cart-Page-Box2">
                  {cart.total_count !== 0 && (
                    <div className="Cart-Info">
                      <h3 className="Cart-Item-Title">Pregled narudžbe</h3>
                      <div className="Page-Line"></div>
                      <div className="Cart-Item">
                        <label>Iznos:</label>
                        <label>
                          {cart.total_price.toFixed(2)}&nbsp;{CURRENCY}
                        </label>
                      </div>
                      <div className="Cart-Item">
                        <label>Dodatni popust:</label>
                        <label>{cart.total_discount} %</label>
                      </div>
                      <div className="Page-Line"></div>
                      <div className="Cart-Item">
                        <label>Iznos sa popustom:</label>
                        <label>
                          {cart.final_price.toFixed(2)}&nbsp;{CURRENCY}
                        </label>
                      </div>
                      <div className="Cart-Item">
                        <label>Poštarina:</label>
                        <label>
                          {getDeliveryPrice(values.receiving_way).toFixed(2)}
                          &nbsp;{CURRENCY}
                        </label>
                      </div>
                      <div className="Page-Line"></div>
                      <div className="Cart-Item Bold">
                        <label>Iznos za plaćanje:</label>
                        <label>
                          {(
                            cart.final_price +
                            getDeliveryPrice(values.receiving_way)
                          ).toFixed(2)}
                          &nbsp;{CURRENCY}
                        </label>
                      </div>

                      {step === 0 && (
                        <>
                          <div className="Cart-Item">
                            <InputField
                              name="promo_code"
                              label={"Promo kod"}
                              required={false}
                              onChange={(event: any) => {
                                handleCustomChange(event, setFieldValue);
                              }}
                            />
                          </div>
                          <button
                            className="Cart-Button"
                            type="button"
                            onClick={(e) => nextStep(values)}
                          >
                            Nastavi dalje
                          </button>
                        </>
                      )}
                      {step === 1 && (
                        <>
                          <div className="Page-Line"></div>
                          <div className="Select-Field">
                            <label
                              className="Select-Field-Label"
                              htmlFor={"method_of_payment"}
                            >
                              {t("nacin_placanja")}
                            </label>
                            <Field
                              className="Select-Field-Selector"
                              as="select"
                              name="method_of_payment"
                              id="method_of_payment"
                              onChange={(event: any) => {
                                handleCustomChange(event, setFieldValue);
                              }}
                            >
                              <option
                                className="Select-Option"
                                value="placanje_prilikom_preuzimanja"
                              >
                                {t("placanje_prilikom_preuzimanja")}
                              </option>
                              {/* <option value="placanje_karticom">
                          {t("placanje_karticom")}
                      </option> */}
                            </Field>
                          </div>
                          <div className="Cart-Item">
                            <CheckBoxField
                              name="agreement"
                              label={t("saglasnost")}
                              type="checkbox"
                              onChange={(event: any) =>
                                handleCheckboxChange(event, setFieldValue)
                              }
                            />
                          </div>
                          <button className="Cart-Button" type="submit">
                            Poručite
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Form>
          )}
        </Formik>
        <RecentArticles slug={null} title={"Istaknuti proizvodi"} />
        <Baners />
      </div>
    </div>
  );
};
export default CartPage;
